import { useState, useEffect, useCallback } from 'react';
import { KlevuConfig } from '@klevu/core';
import { initKlevuConfig } from '/Foundation/Common/code/Helpers/KlevuHelper.ts';

export function useKlevuSetup() {
  const [favourites, setFavourites] = useState<string[]>([]);
  const [isKlevuReady, setIsKlevuReady] = useState(false);

  // Initialize Klevu
  useEffect(() => {
    initKlevuConfig();
    if (!KlevuConfig.default) {
      return;
    }

    setIsKlevuReady(true);
  }, []);

  // Fetch favourites
  const getFavourites = useCallback(() => {
    if (!window._THULEDATA?.isB2CEnabled || !window._THULEDATA?.enableFavorites) return;

    fetch('/api/sitecore/ProductFavorites/GetProductFavorites')
      .then((response) => response.json())
      .then((data) => setFavourites(data))
      .catch(() => setFavourites([]));
  }, []);

  useEffect(() => {
    getFavourites();
  }, [getFavourites]);

  return { favourites, isKlevuReady };
}